import JustificativaControleReclamacaoModel from "@/models/justificativaControleReclamacaoModel";

import { IService } from "./base/iService";

export default class JustificativaControleReclamacaoService extends IService<JustificativaControleReclamacaoModel> {
    constructor() {
        super("JustificativaControleReclamacao");
    }
}
